import FlagIcon from '@mui/icons-material/Flag';
import { v4 as uuidv4 } from 'uuid';
import { useAppDispatch } from '../../../../../app/hooks';
import useScanData from '../../../../scanDataApi/hooks/useScanData';
import MapIconStyleWrapper from '../../../MapIconStyleWrapper';
import { addMapMarker, MapMarker } from '../../../mapSlice';
import { convertStringToLatLng } from '../../../mapUtils';

export const MapMarkerButton = () => {
  const dispatch = useAppDispatch();
  const { currPointScanData } = useScanData();

  const handleAddMarkerClick = () => {
    if (
      currPointScanData &&
      currPointScanData.data &&
      currPointScanData?.data.length > 0
    ) {
      const latLng = convertStringToLatLng(
        currPointScanData.data[0].point_location
      );
      if (latLng) {
        const newMarker: MapMarker = {
          id: uuidv4(),
          lat: latLng.latitude,
          lng: latLng.longitude,
        };
        dispatch(addMapMarker(newMarker));
      }
    }
  };

  return (
    <MapIconStyleWrapper
      icon={<FlagIcon />}
      showClickableCursor
      handleOnClick={handleAddMarkerClick}
    />
  );
};
